export const FORM_ID = "accepted-age-range-form";
